import { ControlType, FormFieldBase } from './form-field-base.model';

export class InputFormField extends FormFieldBase<File> {
  controlType: ControlType = 'file';
}
